import React, { useState } from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

interface ErrorDialogProps {
  title: string;
  details: string;
  onClose: () => void;
}

const cleanErrorMessage = (message: string): string => {
  // Remove duplicate status codes at the beginning (e.g., "403: 403")
  return message.replace(/^(\d+):\s*\1\s*/, "").replace(/^:\s*/, "");
};

const ErrorDialog: React.FC<ErrorDialogProps> = ({ title, details, onClose }) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-lg">
        <div className="flex items-center">
          <FaExclamationCircle className="h-8 w-8 text-red-600 mr-2" />
          <h2 className="text-lg font-bold text-red-600">{title}</h2>
        </div>
        <button
          className="text-sm text-blue-600 underline mt-2"
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? 'Hide Details' : 'Show Details'}
        </button>
        {showDetails && (
          <div className="bg-gray-100 p-2 mt-2 rounded text-sm overflow-auto max-h-40">
            <pre className="whitespace-pre-wrap break-words">
              {cleanErrorMessage(details)}
            </pre>
          </div>
        )}
        <div className="flex justify-end mt-4">
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-red-600"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDialog;
